import { useState, useEffect } from 'react';
import config from '../config';

function parseTriggerLevels(triggerInfo) {
  return {
    ground_elevation: config.convertMetersToFeet(
      triggerInfo.ground_elev_meters
    ),
    action: config.convertMetersToFeet(
      triggerInfo.flood_thresholds_elevs_meters.action
    ),
    minor: config.convertMetersToFeet(
      triggerInfo.flood_thresholds_elevs_meters.minor
    ),
    moderate: config.convertMetersToFeet(
      triggerInfo.flood_thresholds_elevs_meters.moderate
    ),
    major: config.convertMetersToFeet(
      triggerInfo.flood_thresholds_elevs_meters.major
    ),
  };
}

function parseLatLon(triggerInfo) {
  return [triggerInfo.lat.toFixed(6), triggerInfo.lon.toFixed(6)];
}

function parsePublicNote(triggerInfo) {
  return triggerInfo.public_note;
}

async function requestTriggerLevels(stateSchema, locationIDs) {
  const assetID = locationIDs.asset_id;
  const assetTriggerLevelURL =
    config.triggerLevelURL + '/' + stateSchema + '/' + assetID;
  const response = await fetch(assetTriggerLevelURL);
  const data = await response.json();
  if (data.length !== 1) {
    throw new Error(
      `${data.length} triggerInfos (expected 1) returned for asset_id ${locationIDs.asset_id}`
    );
  }
  return [
    parseTriggerLevels(data[0]),
    parseLatLon(data[0]),
    parsePublicNote(data[0]),
  ];
}

export default function useTriggerLevels({ stateSchema, locationIDs }) {
  const [triggerLevels, setTriggerLevels] = useState();
  const [latLon, setLatLon] = useState();
  const [publicNote, setPublicNote] = useState();

  function clearStates() {
    setTriggerLevels();
    setLatLon();
    setPublicNote();
  }

  useEffect(() => {
    if (stateSchema && locationIDs) {
      requestTriggerLevels(stateSchema, locationIDs)
        .then((data) => {
          setTriggerLevels(data[0]);
          setLatLon(data[1]);
          setPublicNote(data[2]);
        })
        .catch((error) => {
          console.error('Error fetching trigger levels: ' + error);
          clearStates();
        });
    } else {
      clearStates();
    }
  }, [stateSchema, locationIDs]);

  return { triggerLevels, latLon, publicNote };
}
